import { useEffect, useState } from "react";
import { useFetch } from "../../../custom/api";
import "../../../styles/Challenges.css";
import "../../../styles/Achievements.css";

function UserRankRow({ entry, sticky, onOpenProfile }) {
  const initial = (entry.name || "?").trim().charAt(0);
  const { myFetch } = useFetch();
  const [badgeCount, setBadgeCount] = useState(null);

  // The synthesized "me" row (when the logged-in user isn't in the visible
  // page) has no real user_id, and opening a preview of yourself from here
  // isn't useful anyway - only real other-user rows are clickable.
  const clickable = !entry.is_me && entry.user_id && entry.user_id !== "me";

  useEffect(() => {
    if (!clickable) return;
    let ignore = false;
    const run = async () => {
      try {
        const resp = await myFetch(`users/${entry.user_id}/achievements`, { method: "GET" });
        const r = await resp.json();
        if (!ignore && r) setBadgeCount(r.total_earned ?? null);
      } catch (e) {
        // non-critical - badge chip just won't show for this row
      }
    };
    run();
    return () => {
      ignore = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entry.user_id]);

  const rowContent = (
    <>
      <span className="leaderboardRank">{entry.rank}</span>
      <span className="leaderboardAvatar" aria-hidden="true">
        {initial}
      </span>
      <span className="leaderboardName yekan">{entry.is_me ? "شما" : entry.name}</span>
      {badgeCount != null && badgeCount > 0 && (
        <span className="leaderboardBadgeChip caption-2 yekan">🏆 {badgeCount}</span>
      )}
      <span className="caption-1 grey-2">{Math.round(entry.completion_percentage)}٪</span>
      <span className="subject-2 purple-1" style={{ fontWeight: "bold" }}>
        {entry.points}
      </span>
    </>
  );

  if (!clickable) {
    return (
      <div
        className={`leaderboardRow ${entry.is_me ? "leaderboardRow-me" : ""} ${
          sticky ? "leaderboardStickyMe" : ""
        }`}
      >
        {rowContent}
      </div>
    );
  }

  return (
    <button
      type="button"
      className={`leaderboardRow leaderboardRowButton ${sticky ? "leaderboardStickyMe" : ""}`}
      onClick={() => onOpenProfile && onOpenProfile(entry)}
    >
      {rowContent}
    </button>
  );
}

export default UserRankRow;
